import AssociationItem from '~/client/src/shared/models/AssociationItem/AssociationItem'
import IFollowingsStore from '~/client/src/shared/models/IFollowingsStore'

import Localization from '../../localization/LocalizationManager'
import BaseFollowingsStore from '../BaseFollowings.store'
import * as e from '../EventStore/eventConstants'

export default class WorkflowFollowingsStore
  extends BaseFollowingsStore
  implements IFollowingsStore
{
  protected readonly saveEventName = e.SAVE_SITE_PERMIT_FOLLOWINGS
  protected readonly deleteEventName = e.DELETE_SITE_PERMIT_FOLLOWINGS

  protected get byId(): Map<string, AssociationItem> {
    return this.eventsStore.appState.workflowFollowings
  }

  protected getSubscribeMessage(
    usersCount: number,
    entitiesCount: number,
  ): string {
    return Localization.translator.usersSubscribedTo.forms(
      usersCount,
      entitiesCount,
    )
  }

  protected getUnsubscribeMessage(
    usersCount: number,
    entitiesCount: number,
  ): string {
    return Localization.translator.usersUnSubscribedFrom.forms(
      usersCount,
      entitiesCount,
    )
  }
}
